import { render, staticRenderFns } from "./InviteTeam.vue?vue&type=template&id=fbb89ccc&"
import script from "./InviteTeam.vue?vue&type=script&lang=js&"
export * from "./InviteTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports